var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"certificate"},[_c('RegisterWrapper',{attrs:{"title":"完善认证信息"}},[_c('PersonCertificate')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }